var $ = require('jquery');

$(document).ready(function() {
    $(".accordion__item-title").on('click', function() {
        let parent = $(this).parent();
        let currentOpenItem = $(this).closest('.accordion__items').find('.is-open');

        if ( currentOpenItem.length ) {
            currentOpenItem.removeClass('is-open');

            // Accessibility
            currentOpenItem.find('.accordion__item-container').attr('aria-expanded', 'false');
            currentOpenItem.find('.accordion__item-link a').attr('tabindex', '-1');
            // - - - - - - -

            animateAccordionItem(currentOpenItem);

            if ( parent[0] == currentOpenItem[0] ) return;
        }

        parent.toggleClass('is-open');

        // Accessibility
        parent.find('.accordion__item-container').attr('aria-expanded', 'true');
        parent.find('.accordion__item-link a').attr('tabindex', '0');
        // - - - - - - -
        
        animateAccordionItem(parent);
    })
})

function animateAccordionItem(item) { 
    let height = item.find('.accordion__item-container')[0].scrollHeight;
    if ( item.hasClass('is-open') ) {
        item.find('.accordion__item-container').css('max-height', height);

        setTimeout(function() {
            window.scrollTo({ top: item.offset().top - $('.site-header__primary').outerHeight(true), behavior: 'smooth' });
        }, 500);

    } else {
        item.find('.accordion__item-container').css('max-height', 0);
    }
}